<template>
	<div class="subject container">
        <div class="row">
            <div class="col-4 icon-master">
                <i class="fa fa-graduation-cap"></i>
            </div>

            <div class="col-8">
                <div class="headline h2 tc">
                    <span>In welchem Fach brauchst Du Hilfe?</span>
                </div>
                <div v-for="(row, index) in rows" v-bind:key="index" class="row">
                    <div class="col-6 input-group">
                        <input type="text" v-model="row.subject" name="subject" placeholder="Schulfach" v-validate="'required'">
                        <button @click="deleteRow(index)" v-if="index!=0" class="delete" >×</button>
                    </div>
                    <div class="col-6 add-button" v-if="index==0">
                        <button @click="addRow" class="button">Fach hinzufügen</button>
                    </div>
                </div>

                <!-- <div class="headline h3 tc">
                    <span>Allgemeine Angaben</span>
                </div> -->
                <div class="row general-data">
                    <div class="col-6 no-padding input-group">
                        <select v-model="year" v-validate="'required'" name="year" >
                            <option value="" selected="selected" disabled="disabled">Jahrgang</option>
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                            <option>5</option>
                            <option>6</option>
                            <option>7</option>
                            <option>8</option>
                            <option>9</option>
                            <option>10</option>
                            <option>11</option>
                            <option>12</option>
                            <option>13</option>
                        </select>
                    </div>
                    <div class="col-6 no-padding input-group">
                        <select v-model="schooltype" v-validate="'required'" name="schooltype" >
                            <option value="" selected disabled="disabled">Schulform</option>
                            <option value="Grundschule" >Grundschule</option>
                            <option value="Gesamtschule" >Gesamtschule</option>
                            <option value="Hauptschule" >Hauptschule</option>
                            <option value="Realschule" >Realschule</option>
                            <option value="Gymnasium" >Gymnasium</option>
                            <option value="Förderschule" >Förderschule</option>
                            <option value="Waldorfschule" >Waldorfschule</option>
                            <option value="Montessorischule" >Montessorischule</option>
                            <option value="Sonstiges" >Sonstiges</option>
                        </select>
                    </div>
                </div>

                {{ this.info }}
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
	name: 'subject',
	components: {
        
	},

	data: function () {
        return {
            rows: [],
            year: '',
            schooltype: '',


            info: null,
        }
    },

    mounted: function() {
        this.addRow(); // Iniial ein Fach hinzufügen
    },

    beforeRouteLeave(to, from, next) {
        // Tells VeeValidate to validate all the fields in the component's scope
        this.$validator.validateAll().then((result) => {
            if (result) {
                next();
                return;
            }
            if(!result){
                console.log(this);                
            }
        });
    },

    methods: {
        addRow() {
          this.rows.push({
            subject: '',
          })
        },
        deleteRow(index) {
          this.rows.splice(index,1)
        },

        nextPage() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    // Success
                    this.$emit('openNextPage', this);
                    return;
                }
                if(!result){
                    // Error
                    console.log(this);                
                }
            });
        }
    }
}
</script>

<style>
    .input-group {
        margin-bottom: 1rem;
        position: relative;
    }
    .delete {
        background: none;
        border: none;
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
        color: #B61500;
        font-weight: bold;
        cursor: pointer;
        outline: 0;
    }
    .add-button {
        text-align: right;
        margin-bottom: 1rem;
    }
    .general-data {
        margin-top: 2rem;
    }
</style>